import { createContentfulProps } from "frontend/contentful/lib/create-contentful-props";
import { RenderContentfulRichText } from "frontend/contentful/components/utils/render-contentful-rich-text";
import { TableEntry } from "frontend/contentful/schema/blocks";
import {
  ColumnHeader,
  TableProps,
} from "design-system/components/blocks/table/table";
import { createComponentHeaderProps } from "../primitives/component-header.props";
import { TableOptions } from "./table.contentful";

export const createTableProps = createContentfulProps<
  TableEntry,
  TableProps,
  TableOptions
>(({ entry, options }) => {
  const headerAbove = options?.headerAbove || false;
  const data = entry.fields.tabularData;
  const transformColumnHeaders: Array<ColumnHeader> =
    data?.columnHeaders.map((header) =>
      typeof header === "string" ? { data: header } : header,
    ) || [];

  const props: TableProps = {
    componentHeader: createComponentHeaderProps(entry.fields.header),
    title: entry.fields.title && (
      <RenderContentfulRichText
        document={entry.fields.title}
        disableParagraphs
      />
    ),
    footerText: entry.fields.footerText && (
      <RenderContentfulRichText document={entry.fields.footerText} />
    ),
    align: entry.fields.alignment || "wide",
    columnGroupHeaders: data?.columnGroupHeaders,
    columnHeaders: transformColumnHeaders,
    rows: data?.rows,
    HeadingLevel: headerAbove ? "h3" : "h2",
    TitleHeadingLevel: headerAbove ? (entry.fields.header ? "h4" : "h3") : "h2",
  };

  return props;
});
